import { render } from "./SlideIntroLayout.vue?vue&type=template&id=793d546a&scoped=true"
import script from "./SlideIntroLayout.vue?vue&type=script&lang=js"
export * from "./SlideIntroLayout.vue?vue&type=script&lang=js"

import "./SlideIntroLayout.vue?vue&type=style&index=0&id=793d546a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793d546a"]])

export default __exports__